var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Matches } from 'class-validator';
import { IsString, Length } from '../../utils/validation/classValidatorWrapper';
export class ManfrediteConfigurationRequest {
    static _OPENAPI_METADATA_FACTORY() {
        return { manfrediteId: { required: false, type: () => Number } };
    }
}
export class ManfrediteValidateSlugRequest {
    static _OPENAPI_METADATA_FACTORY() {
        return { publicProfileSlug: { required: true, type: () => String, pattern: /^[a-z0-9_-]*$/, minLength: 2, maxLength: 100 } };
    }
}
__decorate([
    IsString(),
    Length(2, 100),
    Matches(/^[a-z0-9_-]*$/),
    __metadata("design:type", String)
], ManfrediteValidateSlugRequest.prototype, "publicProfileSlug", void 0);
//# sourceMappingURL=manfrediteConfiguration.dto.js.map